import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "@remix-run/react";
import { Container, Icon, IconAndTitle, Labels, Layout, Text, Title } from './MyVideosTeaser.styles';
import SvgPlaylist from '../../../../../play-core/icons/Playlist';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { usePath } from '../../../config/VideoAppContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MyVideosTeaserContent = ({
  labels
}) => {
  const {
    t
  } = useTranslation();
  const analytics = useAnalyticsDispatch();
  const {
    myVideoPath
  } = usePath();
  const visibleLabels = labels.filter(label => label.count > 0).map(label => t(label.translationKey, {
    count: label.count
  }));
  return /*#__PURE__*/_jsx(Link, {
    to: myVideoPath(),
    onClick: () => analytics({
      type: 'click-event',
      name: 'MyVideosTeaserClick'
    }),
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Layout, {
        children: [/*#__PURE__*/_jsxs(IconAndTitle, {
          children: [/*#__PURE__*/_jsx(Icon, {
            children: /*#__PURE__*/_jsx(SvgPlaylist, {})
          }), /*#__PURE__*/_jsx(Title, {
            children: t('myVideos.title')
          })]
        }), /*#__PURE__*/_jsx(Labels, {
          children: visibleLabels.map(label => /*#__PURE__*/_jsxs(Fragment, {
            children: [/*#__PURE__*/_jsx(Text, {
              children: label
            }), /*#__PURE__*/_jsx("br", {})]
          }, label))
        })]
      })
    })
  });
};